import { render, staticRenderFns } from "./Utlizzo.vue?vue&type=template&id=a27731c6&scoped=true&"
import script from "./Utlizzo.vue?vue&type=script&lang=js&"
export * from "./Utlizzo.vue?vue&type=script&lang=js&"
import style0 from "./Utlizzo.vue?vue&type=style&index=0&id=a27731c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27731c6",
  null
  
)

export default component.exports